const Fez = window.Fez;
if (!Fez) throw new Error('fez runtime not loaded: load fez (window.Fez) before component modules');

// --- name-dialog ---
let __fez_component_0;
{

__fez_component_0 = class {
  PROPS = {
    label: { type: String, default: 'Name' },
    value: String,
    placeholder: String,
    hint: String,
    confirm: { type: String, default: 'Save' },
  }

  submit(event) {
    event.preventDefault()
    const name = (this.formData(event.target).name || '').trim()
    if (!name) return
    window.Dialog.close(name)
  }

  CSS = `:fez {
display:block;
}`

  HTML = `<form onsubmit="fez.submit(event)" novalidate>
<ui-input name="name" label={props.label} value={props.value} placeholder={props.placeholder || ''} hint={props.hint || ''} autofocus required></ui-input>
<div class="dialog-actions">
<ui-button label="Cancel" onclick="Dialog.cancel()"></ui-button>
<ui-button type="submit" variant="primary" label={props.confirm}></ui-button>
</div>
</form>`
};
}

Fez('name-dialog', __fez_component_0);

export default __fez_component_0;
